import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import {
  GetHrActionItemRepository,
  GetHrActionItemResponse,
} from "features/hr/data/repository/hr-appraisal.repository";
import { RootState } from "features/config/store";
import { GetHrActionItemModel } from "features/hr/core/domain/get-hr-action-item.model";
import { GetHrActionItemParam } from "features/hr/core/hr.params";

export enum GetHrActionItemState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: GetHrActionItemState;
  message: string;
  data: GetHrActionItemModel | undefined;
}

let initialState: InitialState = {
  status: GetHrActionItemState.initial,
  message: "",
  data: undefined,
};

export const getHrActionItem = createAsyncThunk(
  "getHrActionItem",
  async (param: GetHrActionItemParam, { rejectWithValue }) => {
    try {
      const response: GetHrActionItemResponse = await GetHrActionItemRepository(
        param
      );
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const getHrActionItemSlice = createSlice({
  name: "getHrActionItem",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHrActionItem.pending, (state) => {
        state.status = GetHrActionItemState.inProgress;
      })
      .addCase(getHrActionItem.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = GetHrActionItemState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(getHrActionItem.rejected, (state, action) => {
        state.status = GetHrActionItemState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectGetHrActionItem = (state: RootState) =>
  state.getHrActionItem;

export default getHrActionItemSlice.reducer;
